jQuery(document).ready((function($){}));
//# sourceMappingURL=scripts.custom.min.js.map
